import { DiveSite } from '../types/DiveSite';

export const diveSiteCatalog: DiveSite[] = [
  {
    id: 'raja-ampat',
    slug: 'raja-ampat',
    name: 'Raja Ampat',
    region: 'Southwest Papua',
    country: 'Indonesia',
    latitude: -0.2333115,
    longitude: 130.5078908,
    matchRadiusKm: 120,
    siteType: 'destination',
    difficulty: 'Intermediate',
    featured: true,
    summary: 'A benchmark destination for coral diversity, dense reef life, and expedition-style diving in the Coral Triangle.',
    highlights: ['Coral biodiversity', 'Pygmy seahorses', 'Reef fish density'],
    tags: ['coral triangle', 'reef', 'macro', 'liveaboard', 'biodiversity'],
    aliases: ['birds head', 'misool', 'waigeo', 'piaynemo'],
  },
  {
    id: 'sipadan',
    slug: 'sipadan',
    name: 'Sipadan',
    region: 'Sabah',
    country: 'Malaysia',
    latitude: 4.114683,
    longitude: 118.628756,
    matchRadiusKm: 20,
    siteType: 'reef',
    difficulty: 'Intermediate',
    featured: true,
    summary: 'An iconic wall-diving island known for turtles, schooling barracuda, and frequent pelagic encounters.',
    highlights: ['Barracuda tornadoes', 'Sea turtles', 'Drop-offs and walls'],
    tags: ['wall', 'turtles', 'pelagics', 'reef'],
    aliases: ['pulau sipadan'],
    requiredCertification: 'AOW',
    requirementNote: 'Commonly treated as an advanced-level destination because of current, exposure, and demanding blue-water conditions.',
  },
  {
    id: 'richelieu-rock',
    slug: 'richelieu-rock',
    name: 'Richelieu Rock',
    region: 'Andaman Sea',
    country: 'Thailand',
    latitude: 9.363333,
    longitude: 98.021944,
    matchRadiusKm: 12,
    siteType: 'reef',
    difficulty: 'Intermediate',
    featured: true,
    summary: 'A solitary pinnacle with a strong mix of macro life and seasonal big-animal action.',
    highlights: ['Whale shark season', 'Purple soft corals', 'Macro critters'],
    tags: ['pinnacle', 'macro', 'whale sharks', 'liveaboard'],
    aliases: ['hin plo naam'],
    requiredCertification: 'AOW',
    requirementNote: 'Usually best suited to advanced divers because of current, surge, and exposed liveaboard profiles.',
  },
  {
    id: 'cocos-island',
    slug: 'cocos-island',
    name: 'Cocos Island',
    region: 'Eastern Pacific',
    country: 'Costa Rica',
    latitude: 5.528056,
    longitude: -87.061111,
    matchRadiusKm: 55,
    siteType: 'destination',
    difficulty: 'Advanced',
    featured: true,
    summary: 'A remote liveaboard destination prized for hammerheads, large pelagics, and exposed blue-water diving.',
    highlights: ['Hammerhead schools', 'Big pelagics', 'Remote expedition feel'],
    tags: ['sharks', 'pelagics', 'advanced', 'liveaboard'],
    aliases: ['isla del coco', 'manuelita', 'bajo alcyone', 'dos amigos'],
    requiredCertification: 'AOW',
    requirementNote: 'Commonly treated as an advanced-level destination because of current, exposure, and demanding blue-water conditions.',
  },
  {
    id: 'galapagos',
    slug: 'galapagos',
    name: 'Galapagos',
    region: 'Galapagos Islands',
    country: 'Ecuador',
    latitude: -0.333333,
    longitude: -90.0,
    matchRadiusKm: 170,
    siteType: 'destination',
    difficulty: 'Advanced',
    featured: true,
    summary: 'A legendary big-animal destination with currents, cooler water, and unforgettable shark encounters.',
    highlights: ['Hammerheads', 'Marine megafauna', 'Outer-island current diving'],
    tags: ['sharks', 'pelagics', 'current', 'advanced', 'liveaboard'],
    requiredCertification: 'AOW',
    requirementNote: 'Usually best suited to advanced divers because of current, surge, and exposed liveaboard profiles.',
    aliases: ['wolf island', 'darwin island', 'galapagos islands'],
  },
  {
    id: 'palau',
    slug: 'palau',
    name: 'Palau',
    region: 'Micronesia',
    country: 'Palau',
    latitude: 7.5,
    longitude: 134.5,
    matchRadiusKm: 140,
    siteType: 'destination',
    difficulty: 'Intermediate',
    featured: true,
    summary: 'A classic Pacific destination combining drift dives, reef sharks, channels, and WWII history.',
    highlights: ['Blue-water drift dives', 'Reef sharks', 'Channel diving'],
    tags: ['drift', 'sharks', 'reef', 'wrecks'],
    aliases: ['blue corner', 'german channel', 'rock islands'],
  },
  {
    id: 'fakarava',
    slug: 'fakarava',
    name: 'Fakarava',
    region: 'Tuamotu Archipelago',
    country: 'French Polynesia',
    latitude: -16.3,
    longitude: -145.633333,
    matchRadiusKm: 45,
    siteType: 'drift',
    difficulty: 'Intermediate',
    featured: true,
    summary: 'A pass-diving destination known for shark density, clean drift dives, and pristine lagoon systems.',
    highlights: ['Grey reef shark walls', 'Pass diving', 'Clear lagoon water'],
    tags: ['drift', 'sharks', 'passes', 'reef'],
    aliases: ['tumakohua', 'tetamanu', 'garuae'],
  },
  {
    id: 'great-blue-hole',
    slug: 'great-blue-hole',
    name: 'Great Blue Hole',
    region: 'Lighthouse Reef',
    country: 'Belize',
    latitude: 17.315278,
    longitude: -87.534444,
    matchRadiusKm: 10,
    siteType: 'blue-hole',
    difficulty: 'Advanced',
    featured: true,
    summary: 'One of diving’s most recognizable sinkholes, famous for its scale, geology, and deep technical appeal.',
    highlights: ['Massive marine sinkhole', 'Stalactite formations', 'Bucket-list blue hole'],
    requiredCertification: 'Tec40',
    requiredGasCertifications: ['nitrox'],
    requirementNote: 'The classic deeper profile is better aligned with technical training and nitrox use than entry-level recreational diving.',
    tags: ['blue hole', 'deep', 'technical', 'iconic'],
    aliases: ['blue hole belize', 'lighthouse reef'],
  },
  {
    id: 'silfra',
    slug: 'silfra',
    name: 'Silfra',
    region: 'Thingvellir National Park',
    country: 'Iceland',
    latitude: 64.254323,
    longitude: -21.117958,
    matchRadiusKm: 5,
    siteType: 'cold-water',
    difficulty: 'Intermediate',
    featured: true,
    summary: 'A cold-water fissure dive celebrated for exceptional visibility and the novelty of diving between tectonic plates.',
    highlights: ['Extreme visibility', 'Tectonic fissure', 'Freshwater drysuit diving'],
    tags: ['cold water', 'freshwater', 'drysuit', 'geology'],
    aliases: ['thingvellir', 'thingvellir national park', 'silfra fissure'],
  },
  {
    id: 'ss-yongala',
    slug: 'ss-yongala',
    name: 'SS Yongala',
    region: 'Queensland',
    country: 'Australia',
    latitude: -19.304444,
    longitude: 147.625278,
    matchRadiusKm: 8,
    siteType: 'wreck',
    difficulty: 'Intermediate',
    featured: true,
    summary: 'A celebrated wreck site where a large historic steamship has become a thriving artificial reef.',
    highlights: ['Large intact wreck', 'Rich fish life', 'Historic shipwreck diving'],
    tags: ['wreck', 'artificial reef', 'marine life'],
    aliases: ['yongala'],
  },
  {
    id: 'ss-thistlegorm',
    slug: 'ss-thistlegorm',
    name: 'SS Thistlegorm',
    region: 'Red Sea',
    country: 'Egypt',
    latitude: 27.814167,
    longitude: 33.92,
    matchRadiusKm: 8,
    siteType: 'wreck',
    difficulty: 'Intermediate',
    featured: true,
    summary: 'A world-famous wartime wreck with accessible cargo holds and one of the strongest reputations in wreck diving.',
    highlights: ['Historic cargo wreck', 'Motorcycles and trucks', 'Classic Red Sea wreck'],
    tags: ['wreck', 'red sea', 'history'],
    aliases: ['thistlegorm'],
  },
  {
    id: 'dahab-blue-hole',
    slug: 'dahab-blue-hole',
    name: 'Blue Hole, Dahab',
    region: 'Sinai Peninsula',
    country: 'Egypt',
    latitude: 28.5725,
    longitude: 34.5369,
    matchRadiusKm: 8,
    siteType: 'blue-hole',
    difficulty: 'Advanced',
    requiredCertification: 'Tec40',
    requirementNote: 'Widely treated as a technical site once divers move beyond the shallow recreational areas.',
    summary: 'A dramatic Red Sea sinkhole better known for technical challenge and notoriety than easy recreational conditions.',
    highlights: ['Deep sinkhole', 'Technical reputation', 'Shore-access Red Sea landmark'],
    tags: ['blue hole', 'technical', 'deep', 'shore'],
    aliases: ['blue hole dahab', 'dahab'],
  },
  {
    id: 'komodo',
    slug: 'komodo',
    name: 'Komodo',
    region: 'Lesser Sunda Islands',
    country: 'Indonesia',
    latitude: -8.55,
    longitude: 119.48,
    matchRadiusKm: 85,
    siteType: 'destination',
    difficulty: 'Advanced',
    summary: 'A current-heavy destination with manta sites, healthy reefs, and rugged topography across the national park.',
    highlights: ['Manta encounters', 'Strong current dives', 'Dramatic reef structure'],
    tags: ['drift', 'mantas', 'current', 'reef'],
    aliases: ['komodo national park', 'batu bolong', 'manta point'],
  },
  {
    id: 'socorro',
    slug: 'socorro',
    name: 'Socorro',
    region: 'Revillagigedo Islands',
    country: 'Mexico',
    latitude: 18.78,
    longitude: -110.95,
    matchRadiusKm: 120,
    siteType: 'destination',
    difficulty: 'Advanced',
    summary: 'A remote pelagic hotspot known for giant mantas, sharks, and open-ocean liveaboard diving.',
    highlights: ['Oceanic mantas', 'Sharks', 'Remote big-animal diving'],
    tags: ['pelagics', 'mantas', 'sharks', 'liveaboard'],
    aliases: ['revillagigedo', 'san benedicto', 'roca partida'],
  },
  {
    id: 'bonaire',
    slug: 'bonaire',
    name: 'Bonaire',
    region: 'Caribbean',
    country: 'Bonaire',
    latitude: 12.17,
    longitude: -68.29,
    matchRadiusKm: 35,
    siteType: 'destination',
    difficulty: 'Beginner',
    summary: 'A shore-diving favorite with easy logistics, reliable conditions, and healthy Caribbean reef structure.',
    highlights: ['Shore diving', 'Easy logistics', 'Consistent reef conditions'],
    tags: ['shore', 'reef', 'caribbean'],
    aliases: ['klein bonaire'],
  },
  {
    id: 'curacao',
    slug: 'curacao',
    name: 'Curacao',
    region: 'Southern Caribbean',
    country: 'Curacao',
    latitude: 12.16957,
    longitude: -68.99,
    matchRadiusKm: 45,
    siteType: 'destination',
    difficulty: 'Beginner',
    summary: 'A shore-diving heavy Caribbean destination with easy logistics, colorful reefs, and a broad mix of house reefs and boat sites.',
    highlights: ['Strong shore-diving culture', 'Easy resort access', 'Consistent reef profiles'],
    tags: ['caribbean', 'shore', 'reef'],
    aliases: ['curaçao', 'willemstad', 'westpunt'],
  },
  {
    id: 'grand-cayman',
    slug: 'grand-cayman',
    name: 'Grand Cayman',
    region: 'Cayman Islands',
    country: 'Cayman Islands',
    latitude: 19.3133,
    longitude: -81.2546,
    matchRadiusKm: 35,
    siteType: 'destination',
    difficulty: 'Beginner',
    featured: true,
    summary: 'A flagship Caribbean destination known for clear water, wall dives, easy resort access, and famous sites like Stingray City.',
    highlights: ['Clear water', 'Wall diving', 'Strong resort and boat-diving infrastructure'],
    tags: ['caribbean', 'reef', 'wall'],
    aliases: ['cayman', 'cayman islands', 'stingray city', 'seven mile beach'],
  },
  {
    id: 'little-cayman-bloody-bay',
    slug: 'little-cayman-bloody-bay',
    name: 'Bloody Bay Wall',
    region: 'Little Cayman',
    country: 'Cayman Islands',
    latitude: 19.706944,
    longitude: -80.090278,
    matchRadiusKm: 12,
    siteType: 'reef',
    difficulty: 'Intermediate',
    featured: true,
    summary: 'An iconic wall-dive area famous for dramatic vertical topography, sponges, and some of the Caribbean’s most celebrated clear-water reef scenery.',
    highlights: ['Sheer wall profiles', 'Large sponge growth', 'Classic Little Cayman reputation'],
    tags: ['caribbean', 'wall', 'reef'],
    aliases: ['bloody bay', 'little cayman wall', 'bloody bay marine park'],
  },
  {
    id: 'cozumel',
    slug: 'cozumel',
    name: 'Cozumel',
    region: 'Quintana Roo',
    country: 'Mexico',
    latitude: 20.422983,
    longitude: -86.922343,
    matchRadiusKm: 40,
    siteType: 'destination',
    difficulty: 'Intermediate',
    featured: true,
    summary: 'A benchmark Caribbean drift-diving destination with clear water, reef walls, and long coral formations along the island’s marine park.',
    highlights: ['Drift diving', 'Marine park reefs', 'Strong Caribbean visibility'],
    tags: ['caribbean', 'drift', 'reef', 'wall'],
    aliases: ['san miguel de cozumel', 'palancar', 'santa rosa wall'],
  },
  {
    id: 'roatan',
    slug: 'roatan',
    name: 'Roatan',
    region: 'Bay Islands',
    country: 'Honduras',
    latitude: 16.317,
    longitude: -86.542,
    matchRadiusKm: 35,
    siteType: 'destination',
    difficulty: 'Beginner',
    summary: 'A major Bay Islands destination with easy reef access, resort diving, and strong value for recreational divers exploring the Mesoamerican Barrier Reef.',
    highlights: ['Barrier reef access', 'Easy resort diving', 'Popular Caribbean training destination'],
    tags: ['caribbean', 'reef', 'shore'],
    aliases: ['west end roatan', 'west bay', 'roatan honduras'],
  },
  {
    id: 'utila',
    slug: 'utila',
    name: 'Utila',
    region: 'Bay Islands',
    country: 'Honduras',
    latitude: 16.099722,
    longitude: -86.930278,
    matchRadiusKm: 20,
    siteType: 'destination',
    difficulty: 'Beginner',
    summary: 'A laid-back Caribbean island known for diver training culture, affordable access, and seasonal whale shark encounters.',
    highlights: ['Training-friendly culture', 'Whale shark season', 'Budget Caribbean diving'],
    tags: ['caribbean', 'reef', 'training', 'whale sharks'],
    aliases: ['utila honduras', 'bay islands utila'],
  },
  {
    id: 'turks-and-caicos',
    slug: 'turks-and-caicos',
    name: 'Turks and Caicos',
    region: 'Turks and Caicos Islands',
    country: 'Turks and Caicos Islands',
    latitude: 21.694,
    longitude: -71.7979,
    matchRadiusKm: 55,
    siteType: 'destination',
    difficulty: 'Intermediate',
    summary: 'A Caribbean wall- and reef-diving destination with strong visibility, healthy reef structure, and broad resort-diving appeal.',
    highlights: ['Wall dives', 'Strong visibility', 'Resort-friendly diving'],
    tags: ['caribbean', 'wall', 'reef'],
    aliases: ['provo', 'providenciales', 'grand turk'],
  },
  {
    id: 'saba',
    slug: 'saba',
    name: 'Saba',
    region: 'Northeastern Caribbean',
    country: 'Caribbean Netherlands',
    latitude: 17.626111,
    longitude: -63.249167,
    matchRadiusKm: 18,
    siteType: 'destination',
    difficulty: 'Intermediate',
    summary: 'A volcanic Caribbean island with protected marine park diving, pinnacles, and a strong reputation for healthy reef life and underwater topography.',
    highlights: ['Volcanic pinnacles', 'Protected marine park', 'Healthy reef structure'],
    tags: ['caribbean', 'reef', 'pinnacle'],
    aliases: ['saba marine park', 'the eye of the needle'],
  },
  {
    id: 'bahamas-exuma',
    slug: 'bahamas-exuma',
    name: 'Exuma Cays',
    region: 'Bahamas',
    country: 'Bahamas',
    latitude: 23.533333,
    longitude: -75.833333,
    matchRadiusKm: 90,
    siteType: 'destination',
    difficulty: 'Intermediate',
    summary: 'A Bahamas destination associated with clear blue water, shark encounters, reefs, and liveaboard-style itineraries across the Exumas.',
    highlights: ['Clear blue-water profiles', 'Shark-focused dives', 'Liveaboard-friendly geography'],
    tags: ['caribbean', 'reef', 'sharks', 'liveaboard'],
    aliases: ['exumas', 'exuma cays bahamas', 'nassau liveaboard'],
  },
  {
    id: 'andros-blue-holes',
    slug: 'andros-blue-holes',
    name: 'Andros Blue Holes',
    region: 'Bahamas',
    country: 'Bahamas',
    latitude: 24.7,
    longitude: -77.8,
    matchRadiusKm: 80,
    siteType: 'blue-hole',
    difficulty: 'Advanced',
    summary: 'A Bahamas area known for inland and ocean blue holes that appeal to adventurous divers interested in geology and technical potential.',
    highlights: ['Blue hole geology', 'Advanced exploration appeal', 'Distinct Bahamas specialty diving'],
    tags: ['caribbean', 'blue hole', 'technical', 'geology'],
    aliases: ['andros', 'bahamas blue holes', 'andros blue holes bahamas'],
  },
  {
    id: 'bayahibe',
    slug: 'bayahibe',
    name: 'Bayahibe',
    region: 'Dominican Republic',
    country: 'Dominican Republic',
    latitude: 18.364444,
    longitude: -68.841667,
    matchRadiusKm: 20,
    siteType: 'destination',
    difficulty: 'Beginner',
    summary: 'A southeast Dominican Republic dive hub with reefs, easy resort access, and nearby wrecks used by many Caribbean vacation divers.',
    highlights: ['Easy resort access', 'Reefs and wrecks', 'Popular Caribbean vacation hub'],
    tags: ['caribbean', 'reef', 'wreck'],
    aliases: ['la romana', 'bayahibe dominican republic', 'dominicus'],
  },
  {
    id: 'isla-mujeres',
    slug: 'isla-mujeres',
    name: 'Isla Mujeres',
    region: 'Quintana Roo',
    country: 'Mexico',
    latitude: 21.231111,
    longitude: -86.731944,
    matchRadiusKm: 35,
    siteType: 'destination',
    difficulty: 'Intermediate',
    summary: 'A northeast Yucatan destination known for reef dives, seasonal whale shark trips, and easy access from Cancun for Caribbean vacation diving.',
    highlights: ['Whale shark season', 'Easy Cancun access', 'Caribbean reef diving'],
    tags: ['caribbean', 'reef', 'mexico', 'whale sharks'],
    aliases: ['isla mujeres mexico', 'cancun whale sharks', 'manchones reef', 'musa cancun'],
  },
  {
    id: 'riviera-maya-cenotes',
    slug: 'riviera-maya-cenotes',
    name: 'Riviera Maya Cenotes',
    region: 'Quintana Roo',
    country: 'Mexico',
    latitude: 20.348889,
    longitude: -87.349722,
    matchRadiusKm: 45,
    siteType: 'blue-hole',
    difficulty: 'Intermediate',
    featured: true,
    summary: 'A cavern and cenote system region famous for haloclines, dramatic light effects, and guided freshwater overhead-style diving in the Yucatan.',
    highlights: ['Cavern light beams', 'Haloclines', 'Iconic Yucatan cenotes'],
    tags: ['caribbean', 'mexico', 'cenote', 'freshwater', 'geology'],
    aliases: ['cenotes', 'dos ojos', 'chac mool', 'taj mahal cenote', 'dreamgate', 'angelita', 'riviera maya cenotes'],
  },
  {
    id: 'banco-chinchorro',
    slug: 'banco-chinchorro',
    name: 'Banco Chinchorro',
    region: 'Quintana Roo',
    country: 'Mexico',
    latitude: 18.583333,
    longitude: -87.316667,
    matchRadiusKm: 45,
    siteType: 'destination',
    difficulty: 'Advanced',
    summary: 'A remote Mexican atoll system known for reefs, crocodile encounters, and scattered wrecks far south of the Riviera Maya.',
    highlights: ['Remote atoll feel', 'Crocodile encounters', 'Reefs and wrecks'],
    tags: ['caribbean', 'mexico', 'reef', 'wreck', 'remote'],
    aliases: ['chinchorro', 'banco chinchorro biosphere reserve', 'mahahual atoll'],
  },
  {
    id: 'ambergris-caye-hol-chan',
    slug: 'ambergris-caye-hol-chan',
    name: 'Ambergris Caye & Hol Chan',
    region: 'Belize Barrier Reef',
    country: 'Belize',
    latitude: 17.846389,
    longitude: -87.961111,
    matchRadiusKm: 25,
    siteType: 'destination',
    difficulty: 'Beginner',
    summary: 'A popular Belize diving base combining easy access from San Pedro with reef dives, nurse shark sites, and barrier reef variety.',
    highlights: ['Hol Chan Marine Reserve', 'Shark Ray Alley', 'Barrier reef access'],
    tags: ['caribbean', 'reef', 'belize', 'training'],
    aliases: ['san pedro belize', 'hol chan', 'shark ray alley', 'ambergris caye belize'],
  },
  {
    id: 'jardines-de-la-reina',
    slug: 'jardines-de-la-reina',
    name: 'Jardines de la Reina',
    region: 'Cuba',
    country: 'Cuba',
    latitude: 20.833333,
    longitude: -78.95,
    matchRadiusKm: 85,
    siteType: 'destination',
    difficulty: 'Advanced',
    featured: true,
    summary: 'A protected Cuban archipelago renowned for healthy reefs, shark encounters, and liveaboard access to one of the Caribbean’s best-preserved marine areas.',
    highlights: ['Protected reefs', 'Silky and reef sharks', 'Remote liveaboard diving'],
    tags: ['caribbean', 'reef', 'sharks', 'liveaboard', 'remote'],
    aliases: ['gardens of the queen', 'jdlr', 'cuba liveaboard'],
  },
  {
    id: 'grenada',
    slug: 'grenada',
    name: 'Grenada',
    region: 'Windward Islands',
    country: 'Grenada',
    latitude: 12.1165,
    longitude: -61.679,
    matchRadiusKm: 35,
    siteType: 'destination',
    difficulty: 'Intermediate',
    summary: 'A southern Caribbean destination with reef, wreck, and sculpture-park diving, plus broad appeal for resort divers and underwater photographers.',
    highlights: ['Bianca C wreck', 'Underwater sculpture park', 'Mix of reefs and wrecks'],
    tags: ['caribbean', 'reef', 'wreck'],
    aliases: ['bianca c', 'molinere underwater sculpture park', 'st georges grenada'],
  },
  {
    id: 'soufriere-st-lucia',
    slug: 'soufriere-st-lucia',
    name: 'Soufriere, St. Lucia',
    region: 'Saint Lucia',
    country: 'Saint Lucia',
    latitude: 13.856944,
    longitude: -61.056944,
    matchRadiusKm: 20,
    siteType: 'reef',
    difficulty: 'Beginner',
    summary: 'A scenic eastern Caribbean dive area with volcanic scenery, reef slopes, and protected marine reserves near the Pitons.',
    highlights: ['Pitons backdrop', 'Protected marine reserve', 'Easy reef profiles'],
    tags: ['caribbean', 'reef', 'volcanic'],
    aliases: ['st lucia', 'soufriere marine management area', 'anse chastanet', 'superman\'s flight'],
  },
  {
    id: 'speyside-tobago',
    slug: 'speyside-tobago',
    name: 'Speyside, Tobago',
    region: 'Tobago',
    country: 'Trinidad and Tobago',
    latitude: 11.2975,
    longitude: -60.538056,
    matchRadiusKm: 22,
    siteType: 'drift',
    difficulty: 'Advanced',
    summary: 'A current- and plankton-rich Tobago region known for drift dives, giant brain corals, and occasional manta activity on the Atlantic side.',
    highlights: ['Drift dives', 'Giant brain corals', 'Atlantic-side pelagic potential'],
    tags: ['caribbean', 'drift', 'reef', 'current'],
    aliases: ['speyside tobago', 'goat island', 'keleston drain', 'trinidad and tobago diving'],
  },
  {
    id: 'florida-keys',
    slug: 'florida-keys',
    name: 'Florida Keys',
    region: 'Florida',
    country: 'United States',
    latitude: 24.817011,
    longitude: -80.813278,
    matchRadiusKm: 120,
    siteType: 'destination',
    difficulty: 'Beginner',
    featured: true,
    summary: 'A broad Florida reef-and-wreck destination spanning Key Largo through Key West with easy access, warm water, and a large recreational training footprint.',
    highlights: ['Accessible boat diving', 'Coral reefs and spur-and-groove formations', 'Large training and charter scene'],
    tags: ['florida', 'keys', 'reef', 'wreck', 'caribbean'],
    aliases: ['key largo', 'islamorada', 'marathon', 'key west', 'upper keys', 'lower keys'],
  },
  {
    id: 'molasses-reef',
    slug: 'molasses-reef',
    name: 'Molasses Reef',
    region: 'Key Largo, Florida',
    country: 'United States',
    latitude: 25.011944,
    longitude: -80.376944,
    matchRadiusKm: 10,
    siteType: 'reef',
    difficulty: 'Beginner',
    featured: true,
    summary: 'One of the most recognizable Key Largo reefs, known for bright coral structure, swim-throughs, and strong beginner-to-intermediate appeal.',
    highlights: ['Elkhorn and star coral structure', 'Shallow reef sections', 'Classic Key Largo charter stop'],
    tags: ['florida', 'keys', 'reef', 'shallow', 'training'],
    aliases: ['molasses', 'key largo reef', 'molasses reef key largo'],
  },
  {
    id: 'christ-of-the-abyss',
    slug: 'christ-of-the-abyss',
    name: 'Christ of the Abyss',
    region: 'Key Largo, Florida',
    country: 'United States',
    latitude: 25.123472,
    longitude: -80.298028,
    matchRadiusKm: 6,
    siteType: 'reef',
    difficulty: 'Beginner',
    summary: 'An iconic shallow statue site inside the Florida Keys National Marine Sanctuary often combined with easy reef dives and snorkel-friendly conditions.',
    highlights: ['Famous underwater statue', 'Very accessible depth', 'Popular photography stop'],
    tags: ['florida', 'keys', 'reef', 'statue', 'shallow'],
    aliases: ['dry rocks', 'key largo statue', 'christ statue key largo'],
  },
  {
    id: 'spiegel-grove',
    slug: 'spiegel-grove',
    name: 'USNS Spiegel Grove',
    region: 'Key Largo, Florida',
    country: 'United States',
    latitude: 25.084167,
    longitude: -80.320833,
    matchRadiusKm: 8,
    siteType: 'wreck',
    difficulty: 'Advanced',
    featured: true,
    summary: 'A massive intentionally sunk vessel off Key Largo that has become one of Florida’s signature wreck dives with depth, scale, and current exposure.',
    highlights: ['Large wreck profile', 'Penetration potential', 'Advanced depth and current conditions'],
    tags: ['florida', 'keys', 'wreck', 'advanced', 'artificial reef'],
    aliases: ['spiegel grove', 'usns spiegel grove key largo'],
    requiredCertification: 'AdvancedWreck',
    requirementNote: 'This site is commonly treated as an advanced wreck dive because of depth, current, and penetration potential.',
  },
  {
    id: 'duane',
    slug: 'duane',
    name: 'USCGC Duane',
    region: 'Key Largo, Florida',
    country: 'United States',
    latitude: 25.099444,
    longitude: -80.296389,
    matchRadiusKm: 8,
    siteType: 'wreck',
    difficulty: 'Advanced',
    summary: 'A classic upright wreck off Key Largo known for schooling fish, blue-water profile shots, and deeper recreational diving.',
    highlights: ['Upright wreck structure', 'Schooling barracuda and jacks', 'Historic Florida Keys wreck site'],
    tags: ['florida', 'keys', 'wreck', 'advanced'],
    aliases: ['uscgc duane', 'duane wreck', 'key largo duane'],
    requiredCertification: 'Wreck',
    requirementNote: 'Usually considered an advanced wreck profile because of depth, current, and blue-water conditions.',
  },
  {
    id: 'alligator-reef',
    slug: 'alligator-reef',
    name: 'Alligator Reef',
    region: 'Islamorada, Florida',
    country: 'United States',
    latitude: 24.855556,
    longitude: -80.618333,
    matchRadiusKm: 10,
    siteType: 'reef',
    difficulty: 'Beginner',
    summary: 'A popular Islamorada reef and lighthouse site with easy reef structure, reef fish, and broad recreational appeal.',
    highlights: ['Lighthouse landmark', 'Shallow coral heads', 'Good visibility in favorable conditions'],
    tags: ['florida', 'keys', 'reef', 'islamorada'],
    aliases: ['alligator reef lighthouse', 'islamorada reef'],
  },
  {
    id: 'looe-key',
    slug: 'looe-key',
    name: 'Looe Key',
    region: 'Lower Keys, Florida',
    country: 'United States',
    latitude: 24.548611,
    longitude: -81.4075,
    matchRadiusKm: 12,
    siteType: 'reef',
    difficulty: 'Beginner',
    featured: true,
    summary: 'One of the best known Lower Keys reef systems, with healthy spur-and-groove sections, schooling fish, and approachable depths.',
    highlights: ['Protected sanctuary reef', 'Spur-and-groove formations', 'Strong Lower Keys reputation'],
    tags: ['florida', 'keys', 'reef', 'lower keys', 'marine sanctuary'],
    aliases: ['looe key reef', 'big pine reef'],
  },
  {
    id: 'blue-heron-bridge',
    slug: 'blue-heron-bridge',
    name: 'Blue Heron Bridge',
    region: 'Riviera Beach, Florida',
    country: 'United States',
    latitude: 26.784722,
    longitude: -80.041667,
    matchRadiusKm: 5,
    siteType: 'reef',
    difficulty: 'Beginner',
    featured: true,
    summary: 'A world-class shore-access macro site in Palm Beach County known for artificial structure, easy entries, and frequent critter hunting.',
    highlights: ['Exceptional macro life', 'Shore entry', 'Photography favorite'],
    tags: ['florida', 'shore', 'macro', 'palm beach', 'south florida', 'night dive'],
    aliases: ['phil foster park', 'bhb', 'blue heron'],
  },
  {
    id: 'breakers-reef',
    slug: 'breakers-reef',
    name: 'Breakers Reef',
    region: 'Palm Beach, Florida',
    country: 'United States',
    latitude: 26.724722,
    longitude: -79.990278,
    matchRadiusKm: 8,
    siteType: 'reef',
    difficulty: 'Intermediate',
    summary: 'A Palm Beach County drift reef known for sea turtles, reef relief, and the kind of live drift profile that defines local diving.',
    highlights: ['Palm Beach drift diving', 'Sea turtles and reef fish', 'Reliable boat-diving favorite'],
    tags: ['florida', 'reef', 'palm beach', 'south florida', 'drift'],
    aliases: ['breakers', 'breakers reef palm beach', 'palm beach breakers'],
  },
  {
    id: 'anna-cecilia',
    slug: 'anna-cecilia',
    name: 'Ana Cecilia',
    region: 'Palm Beach, Florida',
    country: 'United States',
    latitude: 26.7075,
    longitude: -79.969444,
    matchRadiusKm: 8,
    siteType: 'wreck',
    difficulty: 'Intermediate',
    summary: 'A popular Palm Beach wreck on the deeper side of the county wreck corridor, often dived on drift profiles with strong fish life.',
    highlights: ['Palm Beach wreck corridor', 'Drift-style wreck dive', 'Frequent schooling fish'],
    tags: ['florida', 'wreck', 'palm beach', 'south florida', 'drift'],
    aliases: ['ana cecilia wreck', 'palm beach ana cecilia'],
  },
  {
    id: 'mg-111',
    slug: 'mg-111',
    name: 'MG-111',
    region: 'Palm Beach, Florida',
    country: 'United States',
    latitude: 26.720833,
    longitude: -79.974444,
    matchRadiusKm: 8,
    siteType: 'wreck',
    difficulty: 'Intermediate',
    summary: 'A longtime Palm Beach artificial reef and wreck stop often paired with nearby corridor sites on the same drift line.',
    highlights: ['Compact wreck profile', 'Often paired with nearby wrecks', 'Palm Beach charter staple'],
    tags: ['florida', 'wreck', 'palm beach', 'south florida', 'artificial reef'],
    aliases: ['mg111', 'mg 111', 'palm beach mg-111'],
  },
  {
    id: 'jupiter-wreck-trek',
    slug: 'jupiter-wreck-trek',
    name: 'Jupiter Wreck Trek',
    region: 'Jupiter, Florida',
    country: 'United States',
    latitude: 26.959722,
    longitude: -79.982778,
    matchRadiusKm: 14,
    siteType: 'wreck',
    difficulty: 'Intermediate',
    summary: 'A set of closely grouped artificial reefs and wrecks off Jupiter often paired with drift-style profiles and seasonal marine-life encounters.',
    highlights: ['Multiple wrecks in one area', 'Goliath grouper season', 'Palm Beach drift conditions'],
    tags: ['florida', 'wreck', 'jupiter', 'palm beach', 'south florida', 'drift', 'goliath grouper'],
    aliases: ['wreck trek', 'jupiter wrecks', 'area 51', 'esso bonaire', 'zion train'],
  },
  {
    id: 'jupiter-inlet',
    slug: 'jupiter-inlet',
    name: 'Jupiter Inlet Area',
    region: 'Jupiter, Florida',
    country: 'United States',
    latitude: 26.947222,
    longitude: -79.987222,
    matchRadiusKm: 10,
    siteType: 'drift',
    difficulty: 'Advanced',
    summary: 'A shark- and current-oriented Jupiter area profile known for fast drift dives, ledges, and seasonal large-animal encounters.',
    highlights: ['Fast drift conditions', 'Lemon shark season', 'Ledge hunting and pelagic action'],
    tags: ['florida', 'drift', 'jupiter', 'palm beach', 'south florida', 'sharks'],
    aliases: ['jupiter drift', 'jupiter ledge', 'jupiter florida diving'],
  },
  {
    id: 'lauderdale-by-the-sea',
    slug: 'lauderdale-by-the-sea',
    name: 'Lauderdale-by-the-Sea',
    region: 'Fort Lauderdale, Florida',
    country: 'United States',
    latitude: 26.188056,
    longitude: -80.095278,
    matchRadiusKm: 6,
    siteType: 'reef',
    difficulty: 'Beginner',
    summary: 'A famous South Florida shore-diving zone with easy beach entries, nearshore reefs, and strong appeal for relaxed local dives.',
    highlights: ['Easy shore diving', 'Accessible reef line', 'Popular local night dives'],
    tags: ['florida', 'reef', 'shore', 'fort lauderdale', 'south florida'],
    aliases: ['lbts', 'anglins pier reef', 'fort lauderdale shore dive'],
  },
  {
    id: 'lady-luck',
    slug: 'lady-luck',
    name: 'Lady Luck',
    region: 'Pompano Beach, Florida',
    country: 'United States',
    latitude: 26.258056,
    longitude: -80.071944,
    matchRadiusKm: 8,
    siteType: 'wreck',
    difficulty: 'Intermediate',
    summary: 'A popular Pompano wreck and artificial reef with mermaid art features, broad diver appeal, and strong local charter visibility.',
    highlights: ['Distinctive mermaid sculpture', 'Accessible wreck profile', 'Pompano charter favorite'],
    tags: ['florida', 'wreck', 'pompano', 'fort lauderdale', 'south florida'],
    aliases: ['lady luck wreck', 'pompano wreck', 'lady luck pompano'],
  },
  {
    id: 'neptune-memorial-reef',
    slug: 'neptune-memorial-reef',
    name: 'Neptune Memorial Reef',
    region: 'Miami, Florida',
    country: 'United States',
    latitude: 25.850278,
    longitude: -80.096667,
    matchRadiusKm: 8,
    siteType: 'reef',
    difficulty: 'Intermediate',
    summary: 'A distinctive artificial reef off Miami designed as an underwater memorial site with sculptural architecture and easy recognition.',
    highlights: ['Unique underwater architecture', 'Artificial reef concept', 'Recognizable Miami site'],
    tags: ['florida', 'reef', 'miami', 'south florida', 'artificial reef'],
    aliases: ['neptune reef', 'miami memorial reef', 'memorial reef'],
  },
  {
    id: 'half-moon-preserve',
    slug: 'half-moon-preserve',
    name: 'Half Moon Preserve',
    region: 'West Palm Beach, Florida',
    country: 'United States',
    latitude: 26.743611,
    longitude: -79.982222,
    matchRadiusKm: 8,
    siteType: 'wreck',
    difficulty: 'Intermediate',
    summary: 'A Palm Beach wreck-and-reef area centered on the Half Moon and surrounding artificial structures, often dived as part of local drift charters.',
    highlights: ['Historic wreck remains', 'Palm Beach drift line', 'Artificial reef fish life'],
    tags: ['florida', 'wreck', 'palm beach', 'south florida', 'drift'],
    aliases: ['half moon', 'half moon wreck', 'west palm beach wreck'],
  },
  {
    id: 'uss-oriskany',
    slug: 'uss-oriskany',
    name: 'USS Oriskany',
    region: 'Pensacola, Florida',
    country: 'United States',
    latitude: 30.010278,
    longitude: -87.006389,
    matchRadiusKm: 12,
    siteType: 'wreck',
    difficulty: 'Advanced',
    featured: true,
    summary: 'A giant aircraft carrier reefed off Pensacola, widely regarded as one of the most dramatic artificial reef wrecks in the United States.',
    highlights: ['Aircraft carrier scale', 'Deep Gulf wreck profile', 'Technical and advanced appeal'],
    tags: ['florida', 'gulf', 'wreck', 'pensacola', 'west coast florida', 'artificial reef'],
    aliases: ['oriskany', 'uss oriskany wreck'],
    requiredCertification: 'Tec40',
    requiredGasCertifications: ['nitrox'],
    requirementNote: 'The carrier’s depth and scale push this site toward advanced technical-style planning for most divers.',
  },
  {
    id: 'bridge-span-14',
    slug: 'bridge-span-14',
    name: 'Bridge Span 14',
    region: 'Panama City Beach, Florida',
    country: 'United States',
    latitude: 30.0625,
    longitude: -85.726944,
    matchRadiusKm: 8,
    siteType: 'wreck',
    difficulty: 'Intermediate',
    summary: 'A classic Panama City artificial reef site built from bridge rubble and structure that attracts fish life and recreational charter traffic.',
    highlights: ['Panhandle artificial reef', 'Good fish aggregation', 'Frequent charter stop'],
    tags: ['florida', 'gulf', 'west coast florida', 'wreck', 'panama city', 'artificial reef'],
    aliases: ['span 14', 'bridge span', 'panama city bridge span'],
  },
  {
    id: 'st-andrews-jetties',
    slug: 'st-andrews-jetties',
    name: 'St. Andrews Jetties',
    region: 'Panama City Beach, Florida',
    country: 'United States',
    latitude: 30.131111,
    longitude: -85.740556,
    matchRadiusKm: 6,
    siteType: 'reef',
    difficulty: 'Beginner',
    summary: 'A sheltered Panhandle shore and boat-access area with jetty structure, easy conditions on the right tide, and strong training value.',
    highlights: ['Jetty marine life', 'Beginner-friendly conditions', 'Popular training and checkout area'],
    tags: ['florida', 'gulf', 'west coast florida', 'shore', 'training', 'panama city'],
    aliases: ['st andrews', 'st andrews state park', 'panama city jetties'],
  },
  {
    id: 'ss-sheridan',
    slug: 'ss-sheridan',
    name: 'SS Sheridan',
    region: 'St. Pete Beach, Florida',
    country: 'United States',
    latitude: 27.575278,
    longitude: -82.930833,
    matchRadiusKm: 10,
    siteType: 'wreck',
    difficulty: 'Intermediate',
    summary: 'A noted Gulf wreck off the St. Petersburg area that offers a more developed west coast wreck profile than many nearshore reef dives.',
    highlights: ['Recognized Tampa Bay wreck', 'Good fish life', 'Distinct west coast charter destination'],
    tags: ['florida', 'gulf', 'west coast florida', 'tampa bay', 'wreck', 'st pete'],
    aliases: ['sheridan wreck', 'st pete wreck', 'st petersburg sheridan'],
  },
  {
    id: 'blackthorn',
    slug: 'blackthorn',
    name: 'USCGC Blackthorn',
    region: 'Tarpon Springs, Florida',
    country: 'United States',
    latitude: 28.073333,
    longitude: -82.963333,
    matchRadiusKm: 10,
    siteType: 'wreck',
    difficulty: 'Advanced',
    summary: 'A deeper Gulf wreck off the Tampa Bay area with historical significance and a reputation as a serious west coast dive.',
    highlights: ['Historic collision wreck', 'Deeper Gulf profile', 'Advanced west coast option'],
    tags: ['florida', 'gulf', 'west coast florida', 'tampa bay', 'wreck', 'advanced'],
    aliases: ['blackthorn wreck', 'uscgc blackthorn wreck', 'tarpon springs wreck'],
    requiredCertification: 'Wreck',
    requirementNote: 'Typically treated as an advanced wreck site because of depth and Gulf conditions.',
  },
  {
    id: 'venice-fossil-diving',
    slug: 'venice-fossil-diving',
    name: 'Venice Fossil Diving',
    region: 'Venice, Florida',
    country: 'United States',
    latitude: 27.099722,
    longitude: -82.467222,
    matchRadiusKm: 12,
    siteType: 'destination',
    difficulty: 'Beginner',
    featured: true,
    summary: 'The best-known Florida destination for shark teeth and fossil hunting, with nearshore Gulf profiles that attract divers focused on recovery rather than reef scenery.',
    highlights: ['Shark tooth hunting', 'Fossil-led dives', 'Distinctive Venice charter niche'],
    tags: ['florida', 'gulf', 'west coast florida', 'fossil', 'venice', 'training'],
    aliases: ['venice beach fossil diving', 'venice beach', 'venice shark teeth', 'venice fossils'],
  },
  {
    id: 'caspersen-beach',
    slug: 'caspersen-beach',
    name: 'Caspersen Beach',
    region: 'Venice, Florida',
    country: 'United States',
    latitude: 27.0725,
    longitude: -82.450833,
    matchRadiusKm: 8,
    siteType: 'destination',
    difficulty: 'Beginner',
    summary: 'A Venice-area shore and nearshore fossil spot associated with shark tooth finds and Gulf beach-diving access.',
    highlights: ['Shark tooth reputation', 'Shore-access fossil hunting', 'Venice area favorite'],
    tags: ['florida', 'gulf', 'west coast florida', 'fossil', 'shore', 'venice'],
    aliases: ['venice fossil beach', 'caspersen', 'caspersen fossil beach'],
  },
  {
    id: 'hudson-grotto',
    slug: 'hudson-grotto',
    name: 'Hudson Grotto',
    region: 'Hudson, Florida',
    country: 'United States',
    latitude: 28.364722,
    longitude: -82.707222,
    matchRadiusKm: 5,
    siteType: 'cold-water',
    difficulty: 'Intermediate',
    summary: 'A distinctive freshwater sink-style training site on Florida’s west coast, known for overhead-style practice and local technical-diving culture.',
    highlights: ['Training-oriented environment', 'Overhead-style practice', 'West coast freshwater option'],
    tags: ['florida', 'west coast florida', 'training', 'freshwater', 'cavern', 'hudson'],
    aliases: ['hudson grotto dive', 'hudson sink', 'grotto hudson'],
  },
  {
    id: 'blue-grotto',
    slug: 'blue-grotto',
    name: 'Blue Grotto',
    region: 'Williston, Florida',
    country: 'United States',
    latitude: 29.386389,
    longitude: -82.446944,
    matchRadiusKm: 5,
    siteType: 'cold-water',
    difficulty: 'Beginner',
    featured: true,
    summary: 'One of Florida’s best-known freshwater training sites, with a clear spring basin, cavern perimeter, and heavy recreational course usage.',
    highlights: ['Major training destination', 'Clear spring basin', 'Accessible cavern atmosphere'],
    tags: ['florida', 'spring', 'freshwater', 'cavern', 'training'],
    aliases: ['blue grotto williston', 'blue grotto florida'],
  },
  {
    id: 'paradise-springs',
    slug: 'paradise-springs',
    name: 'Paradise Springs',
    region: 'Ocala, Florida',
    country: 'United States',
    latitude: 29.188056,
    longitude: -82.186667,
    matchRadiusKm: 6,
    siteType: 'cold-water',
    difficulty: 'Intermediate',
    summary: 'A private spring and cavern site near Ocala that attracts training, cavern, and technical divers looking for controlled freshwater access.',
    highlights: ['Cavern training access', 'Freshwater visibility', 'Ocala-area dive site'],
    tags: ['florida', 'spring', 'freshwater', 'cavern', 'training'],
    aliases: ['paradise spring', 'ocala springs diving'],
    requiredCertification: 'Cavern',
    requirementNote: 'This site is closely associated with cavern and overhead-environment training.',
  },
  {
    id: 'manatee-springs',
    slug: 'manatee-springs',
    name: 'Manatee Springs',
    region: 'Chiefland, Florida',
    country: 'United States',
    latitude: 29.495556,
    longitude: -82.975278,
    matchRadiusKm: 8,
    siteType: 'cold-water',
    difficulty: 'Intermediate',
    summary: 'A north Florida spring system known for clear freshwater, cavern/cave proximity, and quieter nature-focused diving than the busiest training sites.',
    highlights: ['Freshwater spring basin', 'Nature-heavy setting', 'Cave-country access'],
    tags: ['florida', 'spring', 'freshwater', 'cave', 'training'],
    aliases: ['manatee spring', 'chiefland springs'],
    requiredCertification: 'Cavern',
    requirementNote: 'Divers heading beyond the open basin are moving into overhead-oriented spring and cave-country diving.',
  },
  {
    id: 'ichetucknee-springs',
    slug: 'ichetucknee-springs',
    name: 'Ichetucknee Springs',
    region: 'Fort White, Florida',
    country: 'United States',
    latitude: 29.967353,
    longitude: -82.776061,
    matchRadiusKm: 8,
    siteType: 'spring',
    difficulty: 'Beginner',
    summary: 'A celebrated north Florida spring system known for clear freshwater, a scenic river run, and Blue Hole access that draws snorkelers, recreational divers, and cave-curious visitors.',
    highlights: ['Crystal-clear freshwater', 'Blue Hole attraction', 'Classic north Florida spring run'],
    tags: ['florida', 'spring', 'freshwater', 'north florida', 'river', 'training'],
    aliases: ['ichetucknee', 'ichetucknee spring', 'ichetucknee blue hole', 'ichetucknee river'],
  },
  {
    id: 'vortex-spring',
    slug: 'vortex-spring',
    name: 'Vortex Spring',
    region: 'Ponce de Leon, Florida',
    country: 'United States',
    latitude: 30.712778,
    longitude: -85.950833,
    matchRadiusKm: 8,
    siteType: 'cold-water',
    difficulty: 'Beginner',
    summary: 'A clear Panhandle spring and training site that blends recreational checkout use with cavern and cave interest.',
    highlights: ['Panhandle training destination', 'Clear freshwater basin', 'Popular spring checkout site'],
    tags: ['florida', 'spring', 'freshwater', 'training', 'cavern', 'west coast florida'],
    aliases: ['vortex', 'vortex spring florida', 'ponce de leon spring'],
  },
  {
    id: 'madison-blue-spring',
    slug: 'madison-blue-spring',
    name: 'Madison Blue Spring',
    region: 'Madison, Florida',
    country: 'United States',
    latitude: 30.469444,
    longitude: -83.981667,
    matchRadiusKm: 8,
    siteType: 'cold-water',
    difficulty: 'Intermediate',
    summary: 'A north Florida spring known for striking blue water and strong appeal among both open-water visitors and cave-country divers.',
    highlights: ['Bright blue freshwater basin', 'Cave-country reputation', 'North Florida spring access'],
    tags: ['florida', 'spring', 'freshwater', 'cave', 'training'],
    aliases: ['madison blue', 'madison spring', 'madison blue springs'],
  },
  {
    id: 'troy-spring',
    slug: 'troy-spring',
    name: 'Troy Spring',
    region: 'Branford, Florida',
    country: 'United States',
    latitude: 29.924444,
    longitude: -82.973611,
    matchRadiusKm: 8,
    siteType: 'cold-water',
    difficulty: 'Beginner',
    summary: 'A Suwannee-area spring site known for simple freshwater diving and the nearby remains of the Civil War era steamboat Madison.',
    highlights: ['Historic steamboat remains', 'Simple freshwater profile', 'Quiet spring setting'],
    tags: ['florida', 'spring', 'freshwater', 'training'],
    aliases: ['troy springs', 'branford spring', 'troy spring state park'],
  },
  {
    id: 'devils-den',
    slug: 'devils-den',
    name: 'Devil\'s Den',
    region: 'Williston, Florida',
    country: 'United States',
    latitude: 29.395278,
    longitude: -82.436944,
    matchRadiusKm: 5,
    siteType: 'cold-water',
    difficulty: 'Beginner',
    featured: true,
    summary: 'A prehistoric spring cavern training site in north Florida best known for clear water, constant temperature, and easy recreational cavern exposure.',
    highlights: ['Spring cavern setting', 'Constant clear water', 'Popular training destination'],
    tags: ['florida', 'spring', 'freshwater', 'cavern', 'training'],
    aliases: ['devils den spring', 'devils den williston'],
  },
  {
    id: 'ginnie-springs',
    slug: 'ginnie-springs',
    name: 'Ginnie Springs',
    region: 'High Springs, Florida',
    country: 'United States',
    latitude: 29.834722,
    longitude: -82.6975,
    matchRadiusKm: 8,
    siteType: 'cold-water',
    difficulty: 'Intermediate',
    summary: 'A major freshwater spring and cave-diving landmark in north Florida with crystal-clear water and deep cave-diving heritage.',
    highlights: ['Exceptional visibility', 'Cave and cavern reputation', 'Freshwater spring basin'],
    tags: ['florida', 'spring', 'freshwater', 'cave', 'cavern'],
    aliases: ['ginnie', 'ginnie spring', 'high springs'],
  },
  {
    id: 'rainbow-river',
    slug: 'rainbow-river',
    name: 'Rainbow River',
    region: 'Dunnellon, Florida',
    country: 'United States',
    latitude: 29.108611,
    longitude: -82.440833,
    matchRadiusKm: 10,
    siteType: 'cold-water',
    difficulty: 'Beginner',
    summary: 'A gentle freshwater drift and spring system with excellent visibility, easy profiles, and strong beginner appeal.',
    highlights: ['Freshwater drift profile', 'Great visibility', 'Relaxed training-friendly conditions'],
    tags: ['florida', 'spring', 'freshwater', 'drift', 'beginner'],
    aliases: ['rainbow springs', 'rainbow river florida'],
  },
  {
    id: 'dry-tortugas',
    slug: 'dry-tortugas',
    name: 'Dry Tortugas',
    region: 'Florida Keys, Florida',
    country: 'United States',
    latitude: 24.628611,
    longitude: -82.873194,
    matchRadiusKm: 35,
    siteType: 'destination',
    difficulty: 'Intermediate',
    summary: 'A remote far-west Florida Keys destination with clearer offshore water, reefs, and historic wreck potential around the national park area.',
    highlights: ['Remote Keys feel', 'Historic fort backdrop', 'Offshore reef and wreck potential'],
    tags: ['florida', 'keys', 'remote', 'reef', 'wreck'],
    aliases: ['garden key', 'fort jefferson', 'dry tortugas national park'],
  },
];